import React, { useContext, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import queryString from 'query-string';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import { useAlert } from 'react-alert';
import { AUTH_EXCEPTIONS, verifyError } from '../../../utils/verifyErrors';
import { Input } from '../../../components/Base/Elements';
import Base, { ContentContainer } from '../../../components/Base';
import { ButtonAppWeb, Form, FormControl, InputErrorAppWeb, LinkBaseAppWeb, SignInButtonsAppWeb, } from '../../../assets/styles/GlobalStyles';
import { createCookie } from '../../../utils/cookies';
import { translate } from '../../../i18n/index';
import { LogoAppWeb, } from "../../../components/Base/styled";
import { LoadingContext } from '../../../components/Loading/Loading.context';
import LogoImage from '../../../assets/images/logo-onfarm-box-login.png';
import "./alertCustom.css";

const SignInAppWeb = ({ history }) => {
    const alert = useAlert();
    const hasUsername = history.location.state ? history.location.state.username || '' : '';
    const hasPassword = history.location.state ? history.location.state.password || '' : '';
    const { showLoading, hideLoading } = useContext(LoadingContext);

    useEffect(() => {
        const logout = async () => {
            await Auth.signOut()
        }
        logout();
    }, []);

    return (
        <Base width={430} marginTop="450" isStore={false} isAppWeb={true} isImilk={false} backgroundForm={'#FFF;'}>
            <ContentContainer>

                <LogoAppWeb src={LogoImage} alt="Logo do site" title="OnFarm" />

                <Formik
                    enableReinitialize
                    initialValues={{
                        username: hasUsername,
                        password: hasPassword,
                    }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required(translate('validateRequired')),
                        password: Yup.string().required(translate('validateRequired')),
                    })}
                    onSubmit={async (values, actions) => {
                        if (values) {
                            showLoading();
                            try {
                                const response = await Auth.signIn(values.username.trim(), values.password.trim());
                                if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
                                    history.push({
                                        pathname: '/recuperar-senha-app-web',
                                        search: history.location.search,
                                        state: {
                                            redirect: true,
                                            username: response.username,
                                            oldPassword: values.password
                                        },
                                    });
                                    hideLoading();
                                    return;
                                }
                                createCookie(response);

                                const { location } = history;
                                const search = queryString.parse(location.search);

                                if (Object.keys(search).length && search.login) {
                                    const url = atob(search.login);
                                    window.location.href = `https://${url}`;
                                    return;
                                }

                                history.push({
                                    pathname: '/selecionar-fazenda',
                                    search: history.location.search,
                                });
                                hideLoading();
                                return;

                            } catch (e) {
                                console.log('ERROR LOGIN NOT FOUND:  ', e.code, e.message)
                                alert.show(
                                    <span style={{ backgroundColor: 'white', color: 'black', display: 'flex', flexDirection: 'column', padding: '10px', borderRadius: '5px' }}>
                                        <p>{verifyError(e.code, e.message)}</p>
                                        <a href="https://www.onfarmapp.com.br/app/" target="blank">www.onfarmapp.com.br/app/</a>
                                    </span>, {
                                    closeCopy: 'Fechar',
                                    onClose: () => {
                                        if (
                                            e.code === 'UserNotFoundException' &&
                                            e.message.includes(AUTH_EXCEPTIONS.MISSING_EMAIL_AND_CELLPHONE)
                                        ) {

                                        }
                                    },
                                });
                            }

                            hideLoading();
                        }
                        actions.setSubmitting(false);
                    }}>
                    {({ isSubmitting }) => (

                        <Form>
                            <FormControl>
                                <Field
                                    autocapitalize="off"
                                    isAppWeb={true}
                                    name="username"
                                    placeholder={translate('labelDigiteNomeUsuario')}
                                    component={Input}
                                />
                                <ErrorMessage name="username" component={InputErrorAppWeb} />
                            </FormControl>
                            <FormControl>
                                <Field
                                    type="password"
                                    name="password"
                                    isAppWeb={true}
                                    placeholder={translate('labelDigiteSenha')}
                                    component={Input}
                                />
                                <ErrorMessage name="password" component={InputErrorAppWeb} />
                            </FormControl>
                            <FormControl style={{ display: 'flex', marginTop: 30 }}>
                                <LinkBaseAppWeb
                                    to={{
                                        pathname: '/esqueci-minha-senha-app-web',
                                        search: history.location.search,
                                    }}>
                                    {translate('loginResetPassword')}
                                </LinkBaseAppWeb>
                                <SignInButtonsAppWeb>
                                    <ButtonAppWeb type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? translate('buttonEntering') : translate('buttonEnter')}
                                    </ButtonAppWeb>
                                </SignInButtonsAppWeb>
                            </FormControl>
                        </Form>
                    )}
                </Formik>
            </ContentContainer>
        </Base>
    );
}

export default SignInAppWeb
